import classnames from "classnames";
import React, { ReactNode } from "react";
import { media } from "src/theme";
import styled from "styled-components";

export type IFullWidth = "md" | "lg" | "xl" | "xxl";

interface IWrapper {
  fullWidth?: IFullWidth;
}

const Wrapper = styled.div<IWrapper>`
  /**
    fullWidth under [ sm | md | lg | xl ]
  */
  ${({ fullWidth }: IWrapper): string | undefined => {
    if (fullWidth === "md") {
      return `
        max-width: 100%;
        
        ${media.tablet} {
          max-width: 720px;
        }
        ${media.laptop} {
          max-width: 960px;
        }
        ${media.desktop} {
          max-width: 1000px;
        }
      `;
    }
    if (fullWidth === "lg") {
      return `
        max-width: 100%;
        
        ${media.laptop} {
          max-width: 960px;
        }
        ${media.desktop} {
          max-width: 1000px;
        }
      `;
    }
    if (fullWidth === "xl") {
      return `
        max-width: 100%;

        ${media.desktop} {
          max-width: 1000px;
        }
      `;
    }
    if (fullWidth === "xxl") {
      return `
        max-width: 100%;
      `;
    }
  }}
`;

interface IProps {
  className?: string;
  children: ReactNode;
  noGutter?: boolean; // remove lateral padding
  fullWidth?: IFullWidth;
  fluid?: boolean;
}

const Container = ({
  className,
  children,
  noGutter = false,
  fullWidth,
  fluid,
}: IProps): JSX.Element => {
  return (
    <Wrapper
      fullWidth={fullWidth}
      className={classnames(
        className,
        fluid ? "container-fluid" : "container",
        {
          "px-0": noGutter,
        }
      )}
    >
      {children}
    </Wrapper>
  );
};

export default Container;
